import { lazy, Suspense } from "react";
import type { AuditPageVariant } from "./AuditPage";
import { Dashboard } from "./Dashboard";
import { RecycleBinPage } from "./RecycleBinPage";
import type { Role, Section } from "./domain";
import { useSectionView } from "./sectionView";
import { RouteLoadBoundary, RouteLoading } from "./RouteLoadBoundary";

const AuditPage = lazy(() => import("./AuditPage").then(({ AuditPage }) => ({ default: AuditPage })));
const BusinessDocumentsPage = lazy(() => import("./BusinessDocumentsPage").then(({ BusinessDocumentsPage }) => ({ default: BusinessDocumentsPage })));

export const indicatorViews = ["metrics", "documents", "trash", "audit"] as const;
export type IndicatorView = (typeof indicatorViews)[number];

export function IndicatorsPage({
  role,
  onNavigate,
  displayName,
}: {
  role: Role;
  onNavigate: (section: Section) => void;
  displayName: string;
}) {
  const view = useSectionView(indicatorViews, "metrics");
  if (role !== "admin") return null;
  if (view === "metrics") return <Dashboard onNavigate={onNavigate} displayName={displayName}/>;
  if (view === "trash") return <RecycleBinPage role={role}/>;
  if (view === "documents") return <RouteLoadBoundary resetKey="indicators:documents">
    <Suspense fallback={<RouteLoading label="Загружаем документы…" />}>
      <BusinessDocumentsPage role={role}/>
    </Suspense>
  </RouteLoadBoundary>;
  return <RouteLoadBoundary resetKey={`indicators:${view}`}>
    <Suspense fallback={<RouteLoading label="Загружаем документы…" />}>
      <AuditPage key={view} role={role} variant={view as AuditPageVariant}/>
    </Suspense>
  </RouteLoadBoundary>;
}
